import BenefitsWellness from './BenefitsWellness';

export default BenefitsWellness;
